import React from 'react';
import { PublicLayout } from '../../components/PublicLayout';
import { PublicPageSeo } from '../../components/PublicPageSeo';
import { RelatedLinks } from '../../components/RelatedLinks';
import { getContent } from '../../content/i18n';
import { useLocale, useLocalizedPath } from '../../hooks/useLocale';

export const AboutPage: React.FC = () => {
  const locale = useLocale();
  const localizedPath = useLocalizedPath();
  const content = getContent(locale);
  const { about } = content;
  const homePath = locale === 'en' ? '/en' : '/';
  const pagePath = locale === 'en' ? '/en/about' : '/about';

  return (
    <>
      <PublicPageSeo
        breadcrumbs={[
          { name: content.common.home, path: homePath },
          { name: about.title, path: pagePath },
        ]}
      />
      <PublicLayout
        breadcrumbs={[
          { label: content.common.home, href: localizedPath('/') },
          { label: about.title },
        ]}
      >
        <section className="py-12">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">{about.title}</h1>
          <p className="text-lg text-gray-600 dark:text-gray-300 mb-12">{about.subtitle}</p>

          <div className="space-y-10">
            {about.sections.map((section) => (
              <div key={section.title}>
                <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">{section.title}</h2>
                <p className="text-gray-600 dark:text-gray-300 leading-relaxed">{section.content}</p>
              </div>
            ))}
          </div>
          <p className="mt-10 text-gray-500 dark:text-gray-400 text-sm">{content.common.contactSupport}</p>
        </section>

        <RelatedLinks
          links={[
            { label: locale === 'zh' ? '帮助中心' : 'Help', href: '/help' },
            { label: locale === 'zh' ? '隐私政策' : 'Privacy', href: '/privacy' },
            { label: locale === 'zh' ? '服务条款' : 'Terms', href: '/terms' },
          ]}
        />
      </PublicLayout>
    </>
  );
};
